<template>
    <div class="min-h-full w-full bg-white">
        <div class="mx-auto w-full max-w-screen-2xl pb-40 px-8" ref="innerbody">
            <div class="flex space-x-2">
                <div class="flex-1">
                    <div class="sticky top-0 bg-white px-0 mb-2 z-30">
                        <!-- Some Tabs. -->
                        <div class="flex flex-1 pt-4">
                            <div class="flex-1">
                                <div
                                    class="text-2xl font-bold text-gray-900 border-transparent rounded shadow-none px-2 py-1 -ml-2.5 mb-0">
                                    Scope of Works
                                </div>
                            </div>
                        </div>
                        <div>
                            <div
                                class="flex mt-4 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                                <div class="w-6 flex-shrink-0"></div>
                                <div class="w-16 border-l border-r border-gray-200 px-2 py-1">Ref</div>
                                <div class="flex-1 border-r border-gray-200 px-2 py-1">Description</div>
                                <div class="w-28 -ml-px border-r border-gray-200 px-2 py-1">Quantity</div>
                                <div class="w-6 flex-shrink-0 ml-2"></div>
                            </div>
                        </div>
                    </div>
                    <div :key="viewKey" v-if="loaded">
                        <div v-if="scopeOfWorks && scopeOfWorks.sections">
                            <scope-of-works-section v-for="section in scopeOfWorks.sections" :key="section.id"
                                                    :section="section"
                                                    :ref="'scopeOfWorks'"
                                                    :search="search"
                                                    :readonly="true"
                                                    :show-item-progress="showProgress"
                                                    :show-omitted="showOmitted"
                                                    :latest-progress-report="latestProgressReport"
                            ></scope-of-works-section>
                        </div>
                        <div v-else>
                            <div class="flex space-x-8 pt-4 px-4 m-4 justify-center items-center">
                                <div
                                    class="border border-grey-200 rounded-xl bg-gray-50 w-full h-full p-4 justify-center items-center text-center text-gray-500 italic">
                                    No Scope of Works has yet been defined for this package.
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="w-72 space-y-8 relative pt-4">
                    <div class="w-72 space-y-1 fixed">
                        <div
                            style="overflow-y: auto; padding-right:12px; margin-top:12px; padding-top:12px; top:0px; height:calc(100vh - 250px)">
                            <div class="space-y-1 top-1">
                                <div class="flex w-full ">
                                    <label class="mt-1 text-gray-700 align-baseline font-medium flex-1 flex-grow">Show
                                        Latest Progress Report</label>
                                    <ui-toggle v-model="showProgress"
                                               class="inline-block w-auto flex p-0.5 rounded-xl"></ui-toggle>
                                </div>
                                <div class="flex w-full ">
                                    <label class="mt-1 text-gray-700 align-baseline font-medium flex-1 flex-grow">Show
                                        Omitted Items</label>
                                    <ui-toggle v-model="showOmitted"
                                               class="inline-block w-auto flex p-0.5 rounded-xl"></ui-toggle>
                                </div>
                            </div>
                            <h2 class="text-base font-medium text-gray-700 mt-2 text-center">Search</h2>
                            <div class="relative mt-0.5">
                                <ui-input field="bg-gray-50 pr-10 mx-1 focus:ring-blue-600 focus:border-blue-600"
                                          name="search" v-model="search"></ui-input>
                                <div
                                    class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                                    <i class="fas fa-search"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ScopeOfWorksItem from "./ScopeOfWorksItem.vue";
import ScopeOfWorksTask from "./ScopeOfWorksTask.vue";
import UiToggle from "../../ui/UiToggle.vue";
import ScopeOfWorksSection from "./ScopeOfWorksSection.vue";
import draggable from 'vuedraggable'
import {ProgressReport, ProjectDeliveryScopeOfWorks as ScopeOfWorks} from "@models";
import {resolveNumericText, toCurrency} from "../../../utils"
import moment from "moment";

export default {
    components: {
        ScopeOfWorksSection,
        draggable,
        UiToggle, ScopeOfWorksTask, ScopeOfWorksItem
    },
    props: {
        id: String,
        packageReference: String,
    },
    data() {
        return {
            scopeOfWorks: null,
            loaded: false,
            search: '',
            user: {},
            viewKey: '',
            updateKey: 0,
            showProgress: false,
            showOmitted: false,
            resolveNumericText,
            latestProgressReport: Object,
        }
    },
    computed: {
        moment() {
            return moment
        },
    },
    methods: {
        toCurrency,
        async updateLatest() {
            this.latestProgressReport = await ProgressReport.latest(this.packageReference);
            this.scopeOfWorks = await ScopeOfWorks.find(this.packageReference);
        },
    },
    async mounted() {
        await this.updateLatest()
        this.loaded = true;
        $('#app-content').css('padding', 0);
    },
}
</script>
